angular.module('storefrontApp')
    .component('vcCustomerReviewsNew', {
        templateUrl: 'themes/assets/js/common-components/vcCustomerReviewsNew.tpl.html',
        bindings: {
            storeId: '@',
            productId: '@',
            user: '<',
            productName: '@',
        },
        controller: ['vcCustomerReviewsService', 'dialogService', function (customerReviewService, dialogService) {
            const ctrl = this;

            this.$onInit = function () {};

            ctrl.showSubmitReviewForm = function () {
                customerReviewService.checkIfSubmitAvailable(ctrl.productId)
                    .then(function (res) {
                        // Open through $uibModal (dialogService) so the review popup inherits
                        // the platform focus trap, return-focus and Escape handling shared by
                        // every other dialog (WCAG 2.4.3, #892). The message / form / thanks
                        // states are content branches of the one dialog (customerReviewDialogController).
                        dialogService.showDialog(
                            {
                                available: res.data.allow,
                                message: res.data.message,
                                productId: ctrl.productId,
                                productName: ctrl.productName,
                                user: ctrl.user,
                            },
                            'customerReviewDialogController',
                            'storefront.customer-review-dialog.tpl',
                        );
                    });
            };

            this.$onDestroy = function () {};
        }],
    })

    .controller('customerReviewDialogController', [
        '$scope',
        '$uibModalInstance',
        'vcCustomerReviewsService',
        'focusService',
        'dialogData',
        function ($scope, $uibModalInstance, customerReviewService, focusService, dialogData) {
            $scope.message = dialogData.message;
            $scope.productName = dialogData.productName;
            $scope.submitted = false;

            $scope.reviewForm = {
                review: '',
                userName: '',
                productId: dialogData.productId,
                rating: '',
                title: '',
            };

            // Pre-fill an existing review so a returning reviewer edits rather than
            // duplicates. Only relevant when the form (not a message) is shown.
            if (dialogData.available && !dialogData.message) {
                // storeId intentionally omitted — the original component passed a typo'd
                // `ctrl.storeid` (undefined), i.e. matched by productId only. Preserved
                // to keep pre-fill behaviour identical (#892 is focus-only).
                customerReviewService.searchOwn({ productIds: [dialogData.productId] })
                    .then(function (response) {
                        if (response.data.totalCount > 0) {
                            const existingReview = response.data.results[0];
                            $scope.reviewForm.review = existingReview.review;
                            $scope.reviewForm.rating = existingReview.rating;
                            $scope.reviewForm.userName = existingReview.userName;
                            $scope.reviewForm.title = existingReview.title;
                            $scope.reviewForm.id = existingReview.id;
                        }
                    });

                if (dialogData.user && dialogData.user.isRegisteredUser) {
                    $scope.reviewForm.userName = dialogData.user.fullName;
                }
            }

            // The form lives inside an ng-if (child scope), so its FormController is
            // not on this controller's $scope — the template passes it in, matching
            // the original component's setForm pattern.
            $scope.submit = function (submitReviewForm) {
                if (submitReviewForm.$invalid) {
                    return;
                }

                submitReviewForm.$setSubmitted();

                customerReviewService.addCustomerReview($scope.reviewForm)
                    .then(function () {
                        // Swap to the thank-you state in place. The submitted form (and
                        // the focused submit button) is removed, so move focus to the
                        // thank-you heading — this keeps focus inside the dialog (Escape
                        // keeps working) and announces the confirmation to screen readers.
                        $scope.submitted = true;
                        focusService.focusRegion('customer-review-dialog-title');
                    });
            };

            $scope.close = function () {
                $uibModalInstance.dismiss('cancel');
            };
        }]);
